const DYSTOPIA_RUNTIME_OPTION_NAMES = ["phaserMode", "dystopiaBotFps"] as const;

/** Preserve bot-only runtime controls without forwarding tokens or arbitrary room queries. */
export function withDystopiaRuntimeOptions(roomKey: string, roomSearch: URLSearchParams): string {
  const playUri = new URL(roomKey);
  for (const name of DYSTOPIA_RUNTIME_OPTION_NAMES) {
    const value = roomSearch.get(name);
    if (value !== null) playUri.searchParams.set(name, value);
  }
  return playUri.toString();
}

/** Add the transient WA auth token without corrupting an existing room query. */
export function withDystopiaAuthToken(playUri: string, authToken: string): string {
  const authenticatedPlayUri = new URL(playUri);
  authenticatedPlayUri.searchParams.set("token", authToken);
  return authenticatedPlayUri.toString();
}
